import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface AiCallEntry {
  id: string;
  modulo: string;
  agente: string;
  prompt_version: string;
  modello: string;
  latenza_ms: number;
  token_input: number;
  token_output: number;
  costo_usd: string;
  esito: "success" | "error" | "timeout";
  errore: string | null;
  utente_id: string | null;
  metadati: Record<string, unknown> | null;
  creato_il: string;
}

export interface AiCallBreakdown {
  modulo: string;
  esito: string;
  n: number;
  costo_totale_usd: string;
  token_input: number;
  token_output: number;
  latenza_media_ms: number;
}

export interface AiOpsResponse {
  periodo_giorni: number;
  totale_chiamate_periodo: number;
  totale_costo_usd: string;
  breakdown: AiCallBreakdown[];
  entries: AiCallEntry[];
}

export interface AiOpsFilter {
  modulo?: string;
  esito?: string;
  giorni: number;
  limit?: number;
}

export function useAdminAiOps(filter: AiOpsFilter) {
  const params = new URLSearchParams({
    giorni: String(filter.giorni),
    limit: String(filter.limit ?? 100),
  });
  if (filter.modulo) params.set("modulo", filter.modulo);
  if (filter.esito) params.set("esito", filter.esito);
  return useQuery({
    queryKey: ["admin-ai-ops", filter],
    queryFn: () => apiFetch<AiOpsResponse>(`/api/v1/admin/ai-ops?${params.toString()}`),
    staleTime: 15_000,
  });
}
